import _ from 'lodash';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '@/src/reducers/types';

import Container from './Container/Container';
import Header from './Header/Header';
import { LibraryList } from './LibraryList';
import { RootFilesList } from './RootFilesList';
import { TrashList } from './TrashList';

import { useLibraryListStore } from '../../store/library-list.store';

type ListProps = {
  projectId: string;
  draggingData: any;
};

const List = ({ projectId, draggingData }: ListProps) => {
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);
  const folderId = files.activeFolder?.id;
  const inTrash = files.activeInSidebar?.id === 'trash';
  const permissions = useLibraryListStore((s) => s.permissions);

  useEffect(() => {
    return () => {
      $('#documentViewerModal').modal('hide');
    };
  }, []);

  const inLibrary = files.activeInSidebar?.id === 'library';

  useEffect(() => {
    dispatch({ type: 'RESET_SELECTED_ITEMS' });

    return () => {
      dispatch({ type: 'RESET_SELECTED_ITEMS' });
    };
  }, [inLibrary, inTrash, dispatch, folderId]);

  if (!permissions.library.access) {
    return (
      <Container>
        <Header />
        <p className="noRecordsFound">
          Please coordinate with your CloudCfo team to request access to this library.
        </p>
      </Container>
    );
  }

  if (inTrash) {
    return <TrashList projectId={projectId} draggingData={draggingData} />;
  }

  if (files.activeFolder === 'null') {
    return <RootFilesList projectId={projectId} draggingData={draggingData} />;
  }

  return <LibraryList projectId={projectId} draggingData={draggingData} />;
};

export default List;
